
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'static-item'
})
export default class StaticItem extends Vue {
  @Prop({ type: String })
  private label!: string

  @Prop({ type: Number })
  private width!: number

  @Prop({ type: Boolean, default: !1 })
  private required!: boolean

  @Prop({ type: String, default: 'center' })
  private align!: string
}
